module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-vanishing-cousins.b162894e.jpg";